module.exports = __webpack_public_path__ + "zvetseni-prsou_68_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_68_before.jpg
// module id = 1364
// module chunks = 0